(function () {
  'use strict';

  if (window.location.pathname.replace(/\/+$/, '') !== '/pages/lp' || window.__lvnLpImagesInstalled) return;
  var root = document.getElementById('replo-fullpage-element');
  var script = document.currentScript;
  if (!root || !script) return;
  var imageMap;
  try {
    imageMap = JSON.parse(script.getAttribute('data-lvn-image-map') || '{}');
  } catch (_error) {
    return;
  }
  if (!imageMap || typeof imageMap !== 'object') return;

  var filenames = [
    'gempages_559621678087275640-8670f129-8770-4b7f-8a34-5ba056797dc7.webp',
    'gempages_559621678087275640-80c88293-166c-48c5-8e8f-7c0dbde65f64.webp',
    'gempages_559621678087275640-24eddee2-1af9-4d36-88a4-d3edb3ecac38.webp',
    'gempages_559621678087275640-8756e956-0379-4a0f-a758-b56ef1c1f8ea.webp',
    'gempages_559621678087275640-9a9503e1-85f7-4b55-872d-9f710c4335b2.png'
  ];
  var filenamePattern = filenames.map(function (filename) {
    return filename.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }).join('|');
  if (!filenames.every(function (filename) {
    return typeof imageMap[filename] === 'string' && /^(?:https?:)?\/\//.test(imageMap[filename]);
  })) return;
  window.__lvnLpImagesInstalled = true;
  var legacyImagePattern = new RegExp('(?:https?:)?//(?:www\\.)?luveon\\.com/cdn/shop/files/(' + filenamePattern + ')(?=[?#\\s,]|$)(?:\\?([^\\s,#]*))?(#[^\\s,]*)?', 'g');

  function restoreElement(element) {
    if (!element || element.nodeType !== 1 || !element.matches('img, source')) return;
    ['src', 'srcset'].forEach(function (attribute) {
      var value = element.getAttribute(attribute);
      if (!value) return;
      var restored = value.replace(legacyImagePattern, function (_match, filename, query, fragment) {
        var target = imageMap[filename];
        var parameters = (query || '').split('&').filter(function (parameter) {
          return parameter && !/^v(?:=|$)/i.test(parameter);
        });
        return target + (parameters.length ? (target.indexOf('?') === -1 ? '?' : '&') + parameters.join('&') : '') + (fragment || '');
      });
      if (restored !== value) element.setAttribute(attribute, restored);
    });
  }

  function restoreTree(node) {
    if (!node || node.nodeType !== 1) return;
    restoreElement(node);
    node.querySelectorAll('img, source').forEach(restoreElement);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') restoreElement(mutation.target);
      else mutation.addedNodes.forEach(restoreTree);
    });
  });
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset']
  });
  restoreTree(root);
})();
